module.exports = __webpack_public_path__ + "static/img/logo_sunyung1.411a52ef.png";